module.exports = __webpack_public_path__ + "30171ad3c693d80921b4319ae2408e3b.svg";